/**
 * Lone Sport — PDP sale status badge stays in sync with variant:change.
 */

function lonePdpOnSale(variant) {
  if (!variant) return false;
  const cap = variant.compare_at_price;
  const price = variant.price;
  return cap != null && price != null && cap > price;
}

class LonePdpSaleStatus extends HTMLElement {
  connectedCallback() {
    const id = this.getAttribute('form');
    this._form = id ? document.forms[id] : null;
    this._listener = (e) => {
      this.hidden = !lonePdpOnSale(e.detail?.variant);
    };
    this._form?.addEventListener('variant:change', this._listener);
  }

  disconnectedCallback() {
    this._form?.removeEventListener('variant:change', this._listener);
  }
}

if (!customElements.get('lone-pdp-sale-status')) {
  customElements.define('lone-pdp-sale-status', LonePdpSaleStatus);
}
